import sendGroupCryptoDB from '@/scripts/group-crypto';
import { ActionType } from '@/scripts/group-crypto/type';

type EncryptionResponse<T = any, U = Record<string, any>> = {
  code: number;
  data: T;
} & U;

export const encryptionDBApis = {
  initCrypto(userId: string) {
    return sendGroupCryptoDB(ActionType.initCrypto, {
      params: userId,
    });
  },
  createGroupWithId(groupId: string) {
    return sendGroupCryptoDB(ActionType.createGroupWithId, {
      params: groupId,
    });
  },
  getKeyPacakge() {
    return sendGroupCryptoDB<
      EncryptionResponse<null, { data: string; hash_ref: string }>
    >(ActionType.getKeyPacakge);
  },
  getGroupInfo(groupId: string) {
    return sendGroupCryptoDB<EncryptionResponse<string>>(ActionType.getGroupInfo, {
      params: groupId,
    });
  },
  encryptAddMembers(params: { groupId: string; targetPackages: string[] }) {
    return sendGroupCryptoDB<
      EncryptionResponse<{ welcome: string; commit: string; groupInfo: string }>
    >(ActionType.addMembers, {
      params,
    });
  },
  encryptJoinGroup(params: { groupId: string; welcomeMsg: string }) {
    return sendGroupCryptoDB(ActionType.joinGroup, {
      params,
    });
  },
  leaveGroup(groupId: string) {
    return sendGroupCryptoDB(ActionType.leaveGroup, {
      params: groupId,
    });
  },
  encryptRemoveMembers(params: { groupId: string; userIds: string[] }) {
    return sendGroupCryptoDB<EncryptionResponse<{ commit: string; groupInfo: string }>>(
      ActionType.removeMembers,
      {
        params,
      }
    );
  },
  contains(groupId: string) {
    return sendGroupCryptoDB<EncryptionResponse<string>>(ActionType.contains, {
      params: groupId,
    });
  },
  joinByExternalCommit(params: { groupId: string; groupInfo: string }) {
    return sendGroupCryptoDB<EncryptionResponse<string>>(
      ActionType.joinByExternalCommit,
      {
        params,
      }
    );
  },
  applyCommit(params: { groupId: string; commitMsg: string }) {
    return sendGroupCryptoDB(ActionType.applyCommit, {
      params,
    });
  },
  epoch(groupId: string) {
    return sendGroupCryptoDB<EncryptionResponse<number>>(ActionType.epoch, {
      params: groupId,
    });
  },
  loadGroups(groupIds: string[]) {
    return sendGroupCryptoDB(ActionType.loadGroups, {
      params: groupIds,
    });
  },
  deleteGroup(groupId: string) {
    return sendGroupCryptoDB(ActionType.deleteGroup, {
      params: groupId,
    });
  },
  selfUpdate(groupId: string) {
    return sendGroupCryptoDB(ActionType.selfUpdate, {
      params: groupId,
    });
  },
  encryptMessage(params: { groupId: string; text: string }) {
    return sendGroupCryptoDB<EncryptionResponse<string>>(ActionType.encryptMessage, {
      params,
    });
  },
  decryptMessage(params: { groupId: string; text: string }) {
    return sendGroupCryptoDB<EncryptionResponse<string>>(ActionType.decryptMessage, {
      params,
    });
  },
};
